import registerStyles from '@onehat/ui/src/Functions/registerStyles.js';
import Styles from '../constants/Styles.js';

export default function registerStylesFn() {

	registerStyles(Styles);
	
}
